import styled, { css } from 'styled-components';
import { colors, r4, s4, s8 } from '@ardoq/design-tokens';
import { text2 } from '@ardoq/typography';
import { CloseIcon, ICON_SELECTOR, IconSize } from '@ardoq/icons';
import { StatusType } from './types';
import { perTypeColorMap } from './const';
import { focusRingCSS } from '@ardoq/style-helpers';

type TagWrapperProps = {
  $statusType: StatusType;
  $isDisabled?: boolean;
  $isFocused?: boolean;
  $isClickable?: boolean;
  $isClosable?: boolean;
};

export const LabelWrapper = styled.div``;

const getColorMapCSS = ({
  $statusType,
  $isClickable,
  $isDisabled,
  $isClosable,
}: TagWrapperProps) => {
  const colorMap = $isDisabled
    ? perTypeColorMap[StatusType.DEFAULT]
    : perTypeColorMap[$statusType];

  const iconSelector = $isClosable
    ? `${ICON_SELECTOR}:not(:last-child)`
    : ICON_SELECTOR;

  return css`
    border-color: ${colorMap.borderColor};
    background-color: ${colorMap.backgroundColor};

    ${iconSelector} {
      color: ${colorMap.iconColor};
    }

    ${LabelWrapper} {
      color: ${colorMap.labelColor};
    }

    ${$isClickable &&
    css`
      &:hover {
        border-color: ${colorMap.hoverBorderColor};
      }
    `}

    ${$isDisabled &&
    css`
      pointer-events: none;
      ${iconSelector} {
        color: ${colors.iconActionDisabled};
      }
      ${LabelWrapper} {
        color: ${colors.textDisabled};
      }
      border-color: ${colors.borderDisabled};
      background-color: ${colors.surfaceDisabled};
    `}
  `;
};

const tagWrapperCss = css<TagWrapperProps>`
  padding: 2px 0;
  border: 1px solid red;
  border-radius: ${r4};
  display: inline-flex;
  align-items: center;
  ${text2};
  line-height: 18px;
  vertical-align: bottom;

  ${ICON_SELECTOR} {
    margin: 0 ${s4};
  }

  ${LabelWrapper} {
    &:first-child {
      margin-left: ${s8};
    }
    &:last-child {
      margin-right: ${s8};
    }
  }

  position: relative;
  outline: none;
  ${({ $isFocused }) => $isFocused && focusRingCSS}
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      cursor: pointer;
    `}

  ${getColorMapCSS}
`;

export const TagButtonWrapper = styled.button<TagWrapperProps>`
  ${tagWrapperCss}
`;

export const TagDivWrapper = styled.div<TagWrapperProps>`
  ${tagWrapperCss}
`;

export const TAG_DIV_SELECTOR = TagDivWrapper.toString();

export const TAG_BUTTON_SELECTOR = TagButtonWrapper.toString();

export const TagCloseIcon = styled(CloseIcon).attrs({
  iconSize: IconSize.SMALL,
})`
  cursor: pointer;
  color: ${colors.iconAction};
  &:hover {
    color: ${colors.iconActionHover};
  }
`;

export const CounterWrapper = styled.strong`
  margin-left: ${s4};
  white-space: nowrap;
`;

export const CounterValue = styled.div`
  display: inline-block;
  text-align: center;
  margin: 0 1px;
  min-width: 6px;
`;
